module.exports = __webpack_public_path__ + "img/disablecoin.06d390cb.svg";